<div class="page-not-found">
    <div class="page-not-found__panel">
        <h3>404</h3>
        <p>{{ 'GENERAL.ERROR_404' | translate }} </p>
    </div>
</div>